export type BannerProps = {
  /**
   * The URL of the banner IMG.
   */
  url: string;
  /**
   * The accessibility text of the img for screen readers.
   */
  altText: string;
  /**
   * Uses an explicit rendered height instead of deriving it from the source image ratio.
   * Intended for layouts with a fixed-height design specification.
   */
  fixedHeight?: number;
};

export type ImageDetails = {
  height: number;
  width: number;
};

// ViewJob banner URLs use the url1960x400 asset contract. Keeping this ratio in
// the initial layout prevents the surrounding content from shifting while the
// image loads.
export const DEFAULT_IMAGE_DETAILS: ImageDetails = {
  height: 400,
  width: 1960,
};

export const calculateImageRatio = (image: ImageDetails): number => {
  return image.height / image.width;
};
